import React from "react";
import { renderReservationActions, renderReservationRoomActions } from "./customRenderers";
import { renderEditableInput } from "../../../constants/reactUtilities";
import { renderResRoomHotelEditableSelect } from "../Components/customReactUtilities";
import { Progress } from "reactstrap";
import FilterUtility from "../../common/FilterUtility";
export const reservationsDataColumns = (openSchedule, deleteReservation, getResevationRooms, openMembersList) => {
  return [
    {
      Header: "Reservation",
      id: "reservation_number",
      accessor: "reservation_number",
      style: { textAlign: "center" },
      Filter: ({ onChange }) => <FilterUtility onChange={onChange} type="text" />
    },
    {
      Header: "Schedule Efficiency",
      id: "efficiency",
      accessor: "efficiency",
      style: { textAlign: "center" },
      Filter: ({ onChange }) => <FilterUtility onChange={onChange} type="number" />,
      Cell: cellInfo => {
        return (
          <>
            <div className="clearfix">
              <div className="float-left">
                <div>{cellInfo.value}%</div>
              </div>
            </div>
            <Progress
              className="progress-xs"
              color={
                cellInfo.value <= 25
                  ? "danger"
                  : cellInfo.value <= 50
                  ? "warning"
                  : cellInfo.value <= 90
                  ? "orange"
                  : cellInfo.value > 90 && cellInfo.value <= 100
                  ? "success"
                  : "black"
              }
              value={cellInfo.value}
            />
          </>
        );
      }
    },
    {
      Header: "Pax",
      id: "pax",
      accessor: "pax",
      style: { textAlign: "center" },
      Filter: ({ onChange }) => <FilterUtility onChange={onChange} type="number" />
    },
    {
      Header: "Arrival",
      id: "arrival",
      accessor: "arrival",
      style: { textAlign: "center", overflow: "visible" },
      Filter: ({ onChange }) => <FilterUtility onChange={onChange} type="date" />
    },
    {
      Header: "Departure",
      id: "departure",
      accessor: "departure",
      style: { textAlign: "center" },
      Filter: ({ onChange }) => <FilterUtility onChange={onChange} type="date" />
    },
    {
      Header: "Actions",
      id: "actions",
      filterable: false,
      Cell: renderReservationActions.bind(this, openSchedule, deleteReservation, getResevationRooms, openMembersList),
      style: { textAlign: "center" }
    }
  ];
};

export const reservationRoomsDataColumns = (updateProps, deleteRoom, hotelList) => {
  return [
    {
      Header: "Hotel",
      id: "hotel_id",
      // accessor: "hotel_id",
      Cell: renderResRoomHotelEditableSelect.bind(this, "reservationRooms.data.$.", "hotel_id", true, updateProps, hotelList.data, []),
      style: { overflow: "visible" }
    },
    {
      Header: "Room Number",
      id: "room_number",
      accessor: "room_number",
      Cell: renderEditableInput.bind(this, "reservationRooms.data.$.", "room_number", true, updateProps, "text")
    },
    {
      Header: "Actions",
      id: "actions",
      filterable: false,
      Cell: renderReservationRoomActions.bind(this, deleteRoom)
    }
  ];
};
